import React, { useState } from 'react'
import Button from 'components/shared/Button'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import SearchIcon from '@material-ui/icons/Search'

const DetailRow = ({ label, value }) => (
    <div style={{ display: 'flex', padding: '4px 0' }}>
        <span style={{ fontWeight: 500, width: '160px', flexShrink: 0, color: '#555', fontSize: '13px' }}>{label}</span>
        <span style={{ color: 'var(--neutral-900)', fontSize: '13px' }}>{value ?? '-'}</span>
    </div>
)

const NameResultCard = ({ item, onDotSearch, dotSearchLoading, alreadySearched }) => {
    const [expanded, setExpanded] = useState(false)

    return (
        <div style={{
            border: `1px solid ${alreadySearched ? '#c8e6c9' : 'var(--neutral-200)'}`,
            borderRadius: '8px',
            marginBottom: '12px',
            overflow: 'hidden'
        }}>
            {/* Header row */}
            <div                style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '12px 16px',
                backgroundColor: expanded ? 'var(--bg-canvas)' : alreadySearched ? '#f1f8e9' : '#fff',
                cursor: 'pointer'
            }}                onClick={() => setExpanded(!expanded)}            >
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flex: 1 }}>
                    <div>
                        <div style={{ fontWeight: 600, fontSize: '14px' }}>{item.entityName}</div>
                        {item.dbaName && (
                            <div style={{ fontSize: '12px', color: '#666' }}>DBA: {item.dbaName}</div>
                        )}
                    </div>
                    {item.dotNumber && (
                        <span style={{
                            backgroundColor: 'var(--badge-review-bg)',
                            color: 'var(--rox-lilac-ink)',
                            padding: '2px 8px',
                            borderRadius: '4px',
                            fontSize: '12px',
                            fontWeight: 500
                        }}>
                            DOT: {item.dotNumber}
                        </span>
                    )}
                    {alreadySearched && (
                        <span style={{
                            backgroundColor: '#c8e6c9',
                            color: 'var(--status-approved)',
                            padding: '2px 8px',
                            borderRadius: '4px',
                            fontSize: '11px',
                            fontWeight: 500
                        }}>
                            Already Searched
                        </span>
                    )}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {item.dotNumber && (
                        <Button
                            variant='outlined'
                            color='primary'
                            size='small'
                            onClick={(e) => {
                                e.stopPropagation()
                                onDotSearch(item.dotNumber, item)
                            }}
                            loading={dotSearchLoading}
                            startIcon={<SearchIcon fontSize='small' />}
                        >
                            DOT Search
                        </Button>
                    )}
                    {expanded ? <ExpandLessIcon color="action" /> : <ExpandMoreIcon color="action" />}
                </div>
            </div>

            {/* Expanded content */}
            {expanded && (
                <div style={{ padding: '12px 16px', borderTop: '1px solid #e0e0e0' }}>
                    <div style={{ display: 'flex', gap: '32px', flexWrap: 'wrap' }}>
                        {/* Entity Info */}
                        <div style={{ flex: 1, minWidth: '250px' }}>
                            <h6 style={{ fontSize: '13px', fontWeight: 600, marginBottom: '8px', color: '#333' }}>
                                Entity Information
                            </h6>
                            <DetailRow label="Entity ID" value={item.entityId} />
                            <DetailRow label="Entity Name" value={item.entityName} />
                            <DetailRow label="DBA Name" value={item.dbaName} />
                            <DetailRow label="DOT Number" value={item.dotNumber} />
                            <DetailRow label="DOT Suffix" value={item.dotNumberSuffix} />
                            <DetailRow label="Filer Number" value={item.filerNumber} />
                        </div>

                        {/* Physical Address */}
                        <div style={{ flex: 1, minWidth: '250px' }}>
                            <h6 style={{ fontSize: '13px', fontWeight: 600, marginBottom: '8px', color: '#333' }}>
                                Physical Address
                            </h6>
                            {item.location ? (
                                <>
                                    <DetailRow label="Address" value={item.location.addressLine1} />
                                    {item.location.addressLine2 && <DetailRow label="Address 2" value={item.location.addressLine2} />}
                                    <DetailRow label="City" value={item.location.city} />
                                    <DetailRow label="State" value={item.location.state} />
                                    <DetailRow label="Zip Code" value={item.location.zipCode} />
                                </>
                            ) : (
                                <span style={{ color: '#999', fontSize: '13px' }}>No physical address</span>
                            )}
                        </div>

                        {/* Mailing Address */}
                        <div style={{ flex: 1, minWidth: '250px' }}>
                            <h6 style={{ fontSize: '13px', fontWeight: 600, marginBottom: '8px', color: '#333' }}>
                                Mailing Address
                            </h6>
                            {item.mailingAddress ? (
                                <>
                                    <DetailRow label="Address" value={item.mailingAddress.addressLine1} />
                                    {item.mailingAddress.addressLine2 &&
                                        <DetailRow label="Address 2" value={item.mailingAddress.addressLine2} />
                                    }
                                    <DetailRow label="City" value={item.mailingAddress.city} />
                                    <DetailRow label="State" value={item.mailingAddress.state} />
                                    <DetailRow label="Zip Code" value={item.mailingAddress.zipCode} />
                                </>
                            ) : (
                                <span style={{ color: '#999', fontSize: '13px' }}>No mailing address</span>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
const MotusNameDetail = ({ data, onDotSearch, dotSearchLoading, searchedDots = [] }) => {    if (!data) return null

    const results = data.data || []

    return (
        <div>
            <div style={{ marginBottom: '12px', color: '#555' }}>
                <span style={{ fontWeight: 500 }}>{results.length}</span> result{results.length !== 1 ? 's' : ''} found
            </div>
            {results.length > 0 ? (
                results.map((item) => (
                    <NameResultCard    key={item.entityId}    item={item}    onDotSearch={onDotSearch}    dotSearchLoading={dotSearchLoading}    alreadySearched={searchedDots.includes(item.dotNumber)}/>                ))
            ) : (
                <p>No results found.</p>
            )}
        </div>
    )
}

export default MotusNameDetail